import { ModeSettingEnum } from '@colonist/game-base-types';
import { UIWGameCanvasController } from './UIWGameCanvasController.ts';
import { UIGameManager } from '../../../shared/scripts/ui_game/UIGameManager.ts';
import { UIGameActionsController } from '../../../shared/scripts/ui_game/ui_game_actions/UIGameActionsController.ts';
import { UIGameCardController } from '../../../shared/scripts/ui_game/ui_game_card/UIGameCardController.ts';
import { UIWGameMapController } from './ui_game_map/UIWGameMapController.ts';
import { UIWGameToolTipController } from './ui_game_tooltip/UIWGameToolTipController.ts';
import { UIGameTurnSoundController } from '../../../shared/scripts/ui_game/UIGameTurnSoundController.ts';
import { UIGameGoldTileController } from '../../../shared/scripts/ui_game/ui_game_map/UIGameGoldTileController.ts';
import { UIGameController } from '../../../shared/scripts/ui_game/UIGameController.ts';
import { UIWGameTabVisibilityController } from '../../../../client/web/scripts/ui_game/UIWGameTabVisibilityController.ts';
import { UIGamePauseController } from '../../../shared/scripts/ui_game/UIGamePauseController.ts';
import { UIGameAchievementController } from '../../../shared/scripts/ui_game/ui_game_achievement/UIGameAchievementController.ts';
import { UIGamePopupController } from '../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupController.ts';
export class UIWGameManager extends UIGameManager {
    buildGame(configurations) {
        this.gameController = new UIGameController(this, configurations);
        super.buildGame(configurations);
        new UIWGameTabVisibilityController(this);
        const { mechanicSettlementState, mechanicCityState, mechanicRoadState, mechanicRobberState } = configurations.gameState;
        this.mapController = new UIWGameMapController(this) // Jan 28, 2021. Jeff: Map first so its below containers
        ;
        this.actionsController = new UIGameActionsController(this, mechanicSettlementState, mechanicCityState, mechanicRoadState);
        this.cardController = new UIGameCardController(this, mechanicRobberState);
        new UIGameAchievementController(this);
        new UIGameTurnSoundController(this);
        new UIGamePopupController(this);
        this.pauseController = new UIGamePauseController(this);
        new UIGameGoldTileController(this);
        this.buildOrderDependentControllers(configurations.gameState);
        const isColonistRush = this.gameController.gameSettings.modeSetting == ModeSettingEnum.ColonistRush4P;
        if (isColonistRush) this.addColonistRushBranding();
    }
    buildOrderDependentControllers(gameState) {
        this.mapController.createMap();
        this.buildOptionalMechanics(gameState);
        this.mapController.mapView.sortChildren();
        if (this.originalMapPosition != undefined) {
            this.mapController.mapView.scale.set(this.originalMapPosition.zoom.x, this.originalMapPosition.zoom.y);
            this.mapController.mapView.emit('zoomed', this.mapController.mapView.DEFAULT_ZOOM_EVENT);
            this.mapController.mapView.repositionMap(this.originalMapPosition.location);
        }
    }
    // eslint-disable-next-line class-methods-use-this
    openShareLinkMobileModal(link) {
        throw new Error('Link sharing not supported on web');
    }
    constructor(adController){
        super(adController);
        this.canvasController = new UIWGameCanvasController(this);
        this.toolTipController = new UIWGameToolTipController(this);
    }
}
